import { FETCH_FAQS, FETCH_FAQ_CATEGORIES } from './constants'

export const fetchFaqs = {
  request: (categoryId, deviceId) => ({
    type: FETCH_FAQS.REQUEST,
    deviceId,
    categoryId
  }),
  success: (faqs) => ({ type: FETCH_FAQS.SUCCESS, faqs })
}

export const fetchFaqCategories = {
  request: (deviceId) => ({ type: FETCH_FAQ_CATEGORIES.REQUEST, deviceId }),
  success: (categories) => ({ type: FETCH_FAQ_CATEGORIES.SUCCESS, categories })
}
